export default __webpack_public_path__ + "static/media/033-bell.fab36775.svg";